import { motion } from "framer-motion";
import { Gem, MoveRight } from "lucide-react";

const WA_LINK = "https://wa.me/6285891144895";

const slots = [
  { name: "TOP LEFT", badge: "PERMANEN", price: "1 BGL", testid: "slot-top-left" },
  { name: "BOTTOM LEFT", badge: "PERMANEN", price: "3 BGL", testid: "slot-bottom-left" },
  { name: "TOP RIGHT & BOTTOM", badge: "50% OUT BACK", price: "8 BGL", testid: "slot-top-right-bottom" },
  { name: "RIGHT NO IDENTITY", badge: "50% OUT BACK", price: "CONTACT ADMIN", testid: "slot-right-no-identity" },
];

const special = {
  name: "BJ / CSN / QQ",
  badge: "PERMANEN",
  price: "ONLY FOR BRAND AMBASSADOR",
  testid: "slot-bj-csn-qq",
};

function SlotCard({ slot, index }) {
  const isSpecial = slot.badge === "PERMANEN";
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, delay: index * 0.1, ease: "easeOut" }}
      data-testid={slot.testid}
      className="glass-card rounded-2xl p-6 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-display text-lg font-bold tracking-wider text-emerald-100">{slot.name}</h3>
        <span
          className={`whitespace-nowrap rounded-full border px-3 py-1 text-[9px] font-bold tracking-[0.2em] ${
            isSpecial
              ? "border-emerald-300/40 bg-emerald-400/10 text-emerald-300"
              : "border-amber-300/40 bg-amber-400/10 text-amber-300"
          }`}
        >
          {slot.badge}
        </span>
      </div>

      <div className="mt-6 flex items-center gap-3">
        <Gem
          size={36}
          className="text-emerald-300"
          style={{ filter: "drop-shadow(0 0 12px rgba(52,211,153,0.7))" }}
        />
        <span className="font-display text-2xl font-bold text-emerald-200 text-glow-emerald md:text-3xl">
          {slot.price}
        </span>
      </div>

      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${slot.testid}-join-button`}
        className="font-display mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-emerald-400 to-emerald-500 px-4 py-3 text-sm font-bold tracking-[0.2em] text-[#032117] transition-all duration-300 hover:shadow-[0_0_30px_rgba(52,211,153,0.45)]"
      >
        JOIN HOSTER <MoveRight size={16} />
      </a>
    </motion.div>
  );
}

export default function Pricelist() {
  return (
    <section data-testid="pricelist-page" className="mx-auto min-h-screen max-w-4xl px-6 pb-24 pt-32">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <h1
          data-testid="pricelist-title"
          className="font-display text-3xl font-bold tracking-[0.15em] text-emerald-300 text-glow-emerald md:text-4xl"
        >
          PRICELIST JOIN HOSTER
        </h1>
        <p
          data-testid="pricelist-subtitle"
          className="mt-4 text-xs font-semibold tracking-[0.3em] text-emerald-100/60 md:text-sm"
        >
          SELECT AN AVAILABLE SLOT AND JOIN AS TEAMJAV'S HOSTER
        </p>
        <div className="mx-auto mt-4 h-px w-16 bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
      </motion.div>

      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {slots.map((s, i) => (
          <SlotCard key={s.testid} slot={s} index={i} />
        ))}
      </div>

      <div className="mx-auto mt-6 max-w-md">
        <SlotCard slot={special} index={4} />
      </div>
    </section>
  );
}
